import React, { useEffect, useState } from "react";

import PropTypes from "prop-types";
import clsx from "clsx";

import {
  Box,
  Stepper,
  Step,
  StepLabel,
  StepConnector,
  makeStyles,
  withStyles,
} from "@material-ui/core";
import SettingsIcon from "@material-ui/icons/Settings";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import VideoLabelIcon from "@material-ui/icons/VideoLabel";

import General from "./general";
import BuildingData from "./buildingData";
import PaymentModel from "./paymentModel";
import Cordinators from "./cordinators";
import { COLORS } from "../../../../theme/colors";
import { Success } from "../../../../components/modals/Success";
import { TextButton, Button } from "../../../../components/base";

const QontoConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  active: {
    "& $line": {
      borderColor: `${COLORS.darks[0][6]}`,
    },
  },
  completed: {
    "& $line": {
      borderColor: `${COLORS.darks[0][6]}`,
    },
  },
  line: {
    borderColor: COLORS.darks[0][6],
    borderTopWidth: 3,
    borderRadius: 1,
  },
})(StepConnector);

const useQontoStepIconStyles = makeStyles({
  root: {
    color: COLORS.darks[0][25],
    display: "flex",
    height: 22,
    alignItems: "center",
    padding: "0px 7px",
    borderRadius: "30px",
    background: COLORS.white,
  },
  active: {
    color: COLORS.purple,
    border: `2px solid ${COLORS.gray[1]}`,
  },
  circle: {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
  completed: {
    color: COLORS.blueMagenta,
    zIndex: 1,
    fontSize: 18,
  },
});

function QontoStepIcon(props) {
  const classes = useQontoStepIconStyles();
  const { active } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      <div className={classes.circle} />
    </div>
  );
}

QontoStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
};

const useColorlibStepIconStyles = makeStyles({
  root: {
    backgroundColor: COLORS.silver,
    zIndex: 1,
    color: COLORS.white,
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center",
  },
  active: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  },
  completed: {
    backgroundImage:
      "linear-gradient( 136deg, rgb(242,113,33) 0%, rgb(233,64,87) 50%, rgb(138,35,135) 100%)",
  },
});

function ColorlibStepIcon(props) {
  const classes = useColorlibStepIconStyles();
  const { active, completed } = props;

  const icons = {
    1: <SettingsIcon />,
    2: <GroupAddIcon />,
    3: <VideoLabelIcon />,
  };

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
        [classes.completed]: completed,
      })}
    >
      {icons[String(props.icon)]}
    </div>
  );
}

ColorlibStepIcon.propTypes = {
  active: PropTypes.bool,
  completed: PropTypes.bool,
  icon: PropTypes.node,
};

const useStyles = makeStyles((theme) => ({
  button: {
    marginRight: theme.spacing(1),
  },
  buttonBox: {
    marginTop: 40,
    display: "flex",
    justifyContent: "space-between",
  },
  rightButton: {
    display: "flex",
  },
  label: {
    color: COLORS.purples[0],
    "& .MuiStepLabel-label.MuiStepLabel-active": {
      color: COLORS.purples[0],
    },
  },
  stepDiv: {
    background: COLORS.darks[0][3],
  },
  stepperDiv: {
    width: 600,
    background: COLORS.darks[0][1],
    "&.MuiStepper-root": {
      padding: "24px 0px 0px",
    },
  },
  successMsgStyle: {
    fontSize: 24,
    color: COLORS.green,
    marginBottom: 20,
    marginTop: 40,
  },
  subMsgStyle: {
    fontSize: 20,
    color: COLORS.darks[0][100],
    marginBottom: 10,
    width: 300,
    textAlign: "center",
  },
  rootStyle: {
    width: 500,
    height: 600,
  },
  step: {
    width: 860,
    padding: "46px 26px",
    background: COLORS.darks[0][3],
  },
}));

export const PMSteppers = ({ setOpen, building, onBuildingChange, onDone, showSuccess }) => {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const steps = ["General", "Building Data", "Payment Model", "Building Operations Manager (BOP)"];
  const StepContent = [General, BuildingData, PaymentModel, Cordinators][activeStep];
  const isLastStep = activeStep === steps.length - 1;
  let element = document.getElementById("content");

  useEffect(() => {
    if (element) {
      element.scrollTo(0, 0);
    }
  }, [element, activeStep]);

  const handleNext = () => {
    if (isLastStep) {
      onDone(true);
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box width="100%">
      <Box className={classes.stepDiv}>
        <Stepper
          className={classes.stepperDiv}
          alternativeLabel
          activeStep={activeStep}
          connector={<QontoConnector />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabel StepIconComponent={QontoStepIcon} className={classes.label}>
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>
      </Box>
      {showSuccess ? (
        <Success
          isOpen={true}
          setOpen={setOpen}
          width={150}
          height={150}
          src={"done"}
          rootStyle={classes.rootStyle}
          subMsgStyle={classes.subMsgStyle}
          successMsgStyle={classes.successMsgStyle}
          successMsg="Great, you're done!"
          subMsg="An invitation was just sent to the person in charge to start the onboarding process"
        />
      ) : (
        <>
          <Box className={classes.step}>
            <StepContent building={building} onBuildingChange={onBuildingChange} />
          </Box>
          <Box className={classes.buttonBox}>
            <Box className={classes.leftButton}>
              {activeStep !== 0 && (
                <TextButton text={"PREV"} onClick={handleBack} style={{ margin: 10 }} />
              )}
            </Box>
            <Box className={classes.rightButton}>
              <TextButton
                text="SAVE AND CONTINUE LATER"
                style={{ margin: "10px 40px" }}
                onClick={() => onDone()}
              />
              <Button text={isLastStep ? "DONE!" : "NEXT"} onClick={handleNext} />
            </Box>
          </Box>
        </>
      )}
    </Box>
  );
};
